import React from 'react';

import style from './Paper.module.scss';

interface PaperProps {
  children: React.ReactNode;
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

const Paper: React.FC<PaperProps> = ({ children, className, size }) => {
  let containerClass = className ? `${style.container} ${className}` : style.container;
  if (size) containerClass += ` ${style[size ?? '']}`; // size: sm, md, lg, xl
  return <div className={containerClass}>{children}</div>;
};

export default Paper;
